import dayjs from 'dayjs'
import qs from 'querystring'

const nodes = {
  gitm: '进场',
  pass: [
    {
      ieid: 'E',
      value: '海放(出口)',
    },
    {
      ieid: 'I',
      value: '海放(进口)',
    },
  ],
  tmps: '码放',
  lobd: '装船',
  dsch: '卸船',
  stcs: '提货',
  prld: '配载',
}

export default {
  filters: {
    diff(hours) {
      if (hours === 0) {
        return '刚刚'
      } else if (hours < 24) {
        return '已过去' + hours + '小时'
      } else {
        const days = Math.floor(hours / 24)
        return '已过去' + days + '天'
      }
    },

    node(value, ieid) {
      let node = ''
      if (typeof value === 'string') {
        value = value.toLowerCase()
        node = nodes[value]
        if (node) {
          if (Array.isArray(node)) {
            node = node.find(item => item.ieid === ieid)

            if (node) {
              node = node.value
            }
          }
        }
      }
      return node
    },
  },

  computed: {
    headerCellStyle() {
      return {
        background: '#3bafda',
        color: '#fff',
        'font-size': '12px',
      }
    },

    resultList() {
      return [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '有数据',
          value: 1,
        },
        {
          label: '无数据',
          value: 2,
        },
      ]
    },
  },

  methods: {
    async doPush(bill, ctnr, uid) {
      return this.$axios
        .post(
          `${this.commonJs.localUrl}/schedules/traceOps/pushMessage`,
          qs.stringify({
            uid,
            bill,
            ctnr,
          }),
          {
            headers: {
              authorization: `Bearer ${this.getAuthorization()}`,
            },
          }
        )
        .then(resp => {
          if (resp.data.status === 1) {
            return Promise.resolve(resp)
          }
          return Promise.reject(resp)
        })
    },

    async doSearchShipping(nameCn) {
      return this.$axios.get(
        `${this.commonJs.localUrl}/trace/fore/getShipping`,
        {
          params: {
            nameCn: nameCn,
            ref: '',
          },
          headers: {
            authorization: `Bearer ${this.getAuthorization()}`,
          },
        }
      )
    },

    async doExport(path, query) {
      try {
        const resp = await this.$axios.post(
          `${this.commonJs.localUrl}${path}`,
          query,
          {
            headers: {
              authorization: `Bearer ${this.getAuthorization()}`,
            },
            responseType: 'blob',
          }
        )

        let url = window.URL.createObjectURL(resp.data)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        console.log(resp)
        let contentDisposition = resp.headers['content-disposition']
        console.log('contentDisposition = ' + contentDisposition)
        if (contentDisposition) {
          let fileName = contentDisposition.split('filename=')
          link.setAttribute('download', fileName[1])
          document.body.appendChild(link)
          link.click()
        } else {
          this.$message.error('暂无数据')
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
}

export function handleCurrentTimeData(data) {
  const now = dayjs()
  ;(data || []).forEach(item => {
    let currenttime = item.currenttime
    if (currenttime) {
      const d = dayjs(currenttime, 'YYYY-MM-DD HH:mm:ss')
      item.diffHours = now.diff(d, 'hours')
    }
  })
  return data
}

export function addMillis(date, millis) {
  return dayjs(date, 'YYYY-MM-DD HH:mm:ss')
    .add(millis, 'ms')
    .format('YYYY-MM-DD HH:mm:ss.SSS')
}
